import { render, staticRenderFns } from "./bd.vue?vue&type=template&id=11f2023a&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2023a",
  null
  
)

export default component.exports